import { Controller, useFormContext } from "react-hook-form";

import { NcCheckbox, NcCheckboxProps } from "./nc-checkbox";
import { NcFieldLayout, ncFieldLayoutClasses } from "./nc-field-layout";

export interface NcFormCheckboxProps
  extends Omit<
    NcCheckboxProps,
    "name" | "validate" | "onBlur" | "isSelected" | "value" | "validationBehavior" | "children"
  > {
  name: string; // Was optional in NcCheckboxProps and is now required
  label: string;
  description?: string;
}

export const NcFormCheckbox = ({
  name,
  label,
  description,
  onChange,
  ...props
}: NcFormCheckboxProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { name, value, onChange: formOnChange, onBlur, ref },
        fieldState: { invalid, error },
      }) => (
        <NcFieldLayout>
          <NcCheckbox
            ref={ref}
            name={name}
            onBlur={onBlur}
            validationBehavior="aria"
            isInvalid={invalid}
            onChange={value => {
              onChange?.(value);
              formOnChange(value);
            }}
            isSelected={value}
            {...props}
          >
            {label}
          </NcCheckbox>
          {description && <NcFieldLayout.Description>{description}</NcFieldLayout.Description>}
          {error && <div className={ncFieldLayoutClasses.error}>{error?.message}</div>}
        </NcFieldLayout>
      )}
    />
  );
};
